<template>
  <div>

    <van-nav-bar title="我的收藏" fixed="fixed">
      <template #left>
        <div @click="$back(this)" class="backButton">
          <svg-icon icon-class="backButton" style="width:12px;height:20px;"></svg-icon>
        </div>
      </template>
    </van-nav-bar>

    <div style="padding-top: 46px;background-color: #f4f6fa">
      <div v-if="list.length === 0 && loading === false">
        <van-empty description="暂无收藏"/>
      </div>

      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" :finished-text="list.length === 0?'':'没有更多了'"
                  @load="onLoad" style="background-color: #f4f6fa">


          <div v-for="(value,index) in list">
            <div class="infoBox van-hairline--bottom" @click="$infoDetailJump(value.id)">


              <div class="boxLeft">
                <div class="leftIn">

                  <div class="infoTitle"><span class="infoTitleText">{{
                      value.title.slice(0, 30)
                    }}</span>
                  </div>
                  <div class="summary"><span class="summaryText">{{ $summary(value.summary) }}</span>
                  </div>
                  <div class="infoBottom">
                    <div class="symbolTypeBox">
                      <div class="symbolTypeBoxIn"></div>
                      <div class="symbolType">{{ value.symbol_type_name }}</div>
                    </div>
                    <span class="author">{{ value.author_CN }}</span>
                    <span class="dateShowInfo">{{ $dateChange(value.release_time_check) }}</span>
                  </div>

                </div>
              </div>
              <div class="boxRight">

                <div class="rightIn">

                  <img :src="value.cover" style="height: 100%;width: 100%;border-radius: 4px;">

                </div>
              </div>
            </div>


          </div>


        </van-list>
      </van-pull-refresh>
    </div>

  </div>
</template>

<script>
export default {
  name: "collection",
  data() {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      query: {},
      list: []
    }
  },
  methods: {
    onLoad() {
      if (this.refreshing) {
        this.list = []
        this.refreshing = false;
      }

      this.query.member_uuid = localStorage.getItem('member_uuid')
      this.query.api_token = localStorage.getItem('api_token')
      this.query.information_type = 2
      this.query.page_size = 10

      let query = this.$encrypt(this.$genQuery(this.query))
      this.$get(this.$store.state.apiUrl + '/information/Collection', {qdata: query}).then(res => {

        if (res.status === 50001) {
          this.$toast(res.msg);
          this.loading = false;
          this.finished = true;
          this.$back(this)
        } else if (res.data.list) {
          if (res.data.list.length > 0){
            for (let i = 0; i < res.data.list.length; i++) {
              this.list.push(res.data.list[i]);
            }
            this.query.last_id = res.data.list[res.data.list.length - 1].id;
          }
          this.loading = false;
          this.$forceUpdate();
          if (res.data.list.length === 0 || res.data.list.length % 10 !== 0) {
            this.finished = true;
          }


        }






      }).catch(err => {
        console.log(err)
      })


    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.list = [];
      this.query.last_id = 0;


      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },

  },
  mounted() {
    if (!this.$store.state.SignedIn) {
      this.$back(this)
    }
  }
}
</script>

<style scoped>

</style>
